<template>
  <div class="flight-results-wrapper flight-results-wrapper-error">
    <div class="message-bubble assistant flight-card-bubble flight-card-error">
      <span class="flight-options-icon icon icon-alert-triangle" />
      <span>{{ errorMessage }}</span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
	errorMessage: {
		type: String,
		required: true
	}
});

</script>


<style scoped lang="scss">
.flight-results-wrapper-error {
  margin: 0;
}

.flight-card-error {
    color: $color-red-700;
    border: .1rem solid $color-red-700;
    display: flex;
    align-items: center;
    gap: .5rem;
    padding: 1rem;
    display: none;
    margin: 0;
}
</style>
